import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
} from '@mui/material';
import { motion } from 'framer-motion';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';

const Services: React.FC = () => {
  const navigate = useNavigate();
  const services = [
    {
      title: 'Accounting',
      items: [
        'Taxation and bookkeeping',
        'Business advisory',
        'Superannuation services',
        'Corporate compliance',
        'International tax & transfer Pricing',
      ],
    },
    // {
    //   title: 'Migration',
    //   items: [
    //     'Visa application',
    //     'Migration strategy and eligibility assessment',
    //     'Permanent residency and citizenship services',
    //     'Employer nomination and sponsorship advice',
    //     'Visa compliance and condition monitoring',
    //   ],
    // },
    // {
    //   title: 'Legal',
    //   items: [
    //     'Property and construction',
    //     'Corporate and commercial',
    //     'International law and foreign investment',
    //     'Litigation and dispute resolution',
    //     'Family law',
    //   ],
    // },
  ];

  return (
    
    <Box id="services" sx={{ py: { xs: 0, md: 0 }, backgroundColor: 'background.paper' }}>
      {/* Our Services Section */}
      <Box sx={{ py: { xs: 3, md:6 }, backgroundColor: 'background.default' }}>
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Button
                  variant="contained"
                  color="secondary"
                  size="large"
                  onClick={() => navigate('/accounting')}
                  sx={{
                    px: 4,
                    py: 2,
                    fontSize: '1.1rem',
                    fontWeight: 500,
                    width: '100%',
                  }}
                >
                  Abarcar Accounting
                </Button>
            </Grid>
            {/*<Grid item xs={12} md={6}>*/}
            {/*    <Button*/}
            {/*      variant="contained"*/}
            {/*      color="secondary"*/}
            {/*      size="large"*/}
            {/*      onClick={() => navigate('/legal-migration')}*/}
            {/*      sx={{*/}
            {/*        px: 4,*/}
            {/*        py: 2,*/}
            {/*        fontSize: '1.1rem',*/}
            {/*        fontWeight: 500,*/}
            {/*        width: '100%',*/}
            {/*      }}*/}
            {/*    >*/}
            {/*      Abarcar Legal & Migration*/}
            {/*    </Button>*/}
            {/*</Grid>*/}
          </Grid>
        </Container>
      </Box>
      
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          sx={{
            mt: 12,
            mb: 2,
            fontWeight: 600,
            fontSize: { xs: '2rem', md: '2.5rem' },
          }}
        >
          Our Areas of Practice
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 8,
            maxWidth: '800px',
            mx: 'auto',
            fontSize: '1.1rem',
            lineHeight: 1.8,
            color: 'text.secondary',
          }}
        >
          We provide comprehensive professional services across multiple disciplines,
          ensuring our clients receive integrated solutions for their business needs.
        </Typography>
        <Grid container spacing={4} sx={{ pb: 4 }}>
          {services.map((service, index) => (
            <Grid item xs={12} md={12} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <Card
                  sx={{
                    height: '480px',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#F5F1ED',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)',
                    transition: 'transform 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                    },
                  }}
                >
                  <CardContent 
                    sx={{ 
                      flexGrow: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      p: 4,
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        mb: 3,
                        fontWeight: 600,
                        color: 'primary.main',
                      }}
                    >
                      {service.title}
                    </Typography>
                    <List sx={{ flexGrow: 1 }}>
                      {service.items.map((item, itemIndex) => (
                        <ListItem key={itemIndex} sx={{ px: 0 }}>
                          <ListItemIcon sx={{ minWidth: 40 }}>
                            <CheckCircleIcon color="secondary" />
                          </ListItemIcon>
                          <ListItemText
                            primary={item}
                            sx={{
                              '& .MuiListItemText-primary': {
                                color: 'text.secondary',
                                fontSize: '1rem',
                                lineHeight: 1.6,
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services; 